import React, { useState } from "react";

import errors from "../../Utils/ExtractErrors";

import { Modal, Loader, Dimmer, Step, Icon } from "semantic-ui-react";
import { toast } from "react-toastify";

import ModalApp from "../../components/ModalApp";
import TrocaRepository from "../../Repositories/ExchangeRepository";
import { eStatusTroca, eStepTroca } from "../../interfaces";
import CustomLoader from "../../components/CustomLoader";

interface State {
    status: eStatusTroca;
    step: eStepTroca;
}

interface Props {
    trocaId: string;
}

const initialState: State = {
    status: eStatusTroca.Pendente,
    step: eStepTroca.EnviadoParaEmpresa
}

const StepTroca: React.FC<Props> = (props) => {
    const [open, setOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<State>(initialState);

    const load = async () => {
        setLoading(true);
        try {
            const { status, step } = await TrocaRepository.GetById(props.trocaId);
            setState({ status, step });
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }
            const error = errors.getAllErrors(err.response.data);
            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    }

    const handleOpen = () => {
        load();
        setOpen(true);
    }

    const handleClose = () => {
        setState(initialState);
        setOpen(false);
    }

    const detalhesContent = (
        <Modal.Content scrolling>
            {loading &&
                <CustomLoader />
            }
            {!loading &&
                <Step.Group vertical fluid>
                    <Step
                        active={state.status === eStatusTroca.NaoVeioNaPasta}
                        disabled={state.status !== eStatusTroca.NaoVeioNaPasta}
                    >
                        <Icon name="thumbs down" color={state.status === eStatusTroca.NaoVeioNaPasta ? "black" : undefined} />
                        <Step.Content>
                            <Step.Title>Não Chegou na Empresa</Step.Title>
                            <Step.Description>A peça cadastrada, não veio dentro da pasta da Representante.</Step.Description>
                        </Step.Content>
                    </Step>
                    <Step
                        active={state.status === eStatusTroca.Pendente}
                        disabled={state.status !== eStatusTroca.Pendente}
                    >
                        <Icon name="clock" color={state.status === eStatusTroca.Pendente ? "blue" : undefined} />
                        <Step.Content>
                            <Step.Title>Pendente</Step.Title>
                            <Step.Description>Troca pendente, analisando condições da peça.</Step.Description>
                        </Step.Content>
                    </Step>
                    <Step
                        active={state.status === eStatusTroca.Efetuada}
                        disabled={state.status !== eStatusTroca.Efetuada}
                    >
                        <Icon name="check circle" color={state.status === eStatusTroca.Efetuada ? "green" : undefined} />
                        <Step.Content>
                            <Step.Title>Efetuada</Step.Title>
                            <Step.Description>Troca efetuada, preparando envio.</Step.Description>
                        </Step.Content>
                    </Step>
                    <Step
                        active={state.status === eStatusTroca.NaoEfetuada}
                        disabled={state.status !== eStatusTroca.NaoEfetuada}
                    >
                        <Icon name="times circle" color={state.status === eStatusTroca.NaoEfetuada ? "red" : undefined} />
                        <Step.Content>
                            <Step.Title>Não Efetuada</Step.Title>
                            <Step.Description>Identificado mau uso, preparando envio.</Step.Description>
                        </Step.Content>
                    </Step>
                    <Step
                        active={state.status === eStatusTroca.Devedor}
                        disabled={state.status !== eStatusTroca.Devedor}
                    >
                        <Icon name="user times" color={state.status === eStatusTroca.Devedor ? "red" : undefined} />
                        <Step.Content>
                            <Step.Title>Devedor</Step.Title>
                            <Step.Description>Revendedor possui débitos com a empresa, a troca não foi autorizada.</Step.Description>
                        </Step.Content>
                    </Step>
                </Step.Group>
            }
        </Modal.Content>
    );

    return (
        <ModalApp
            open={open}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title="Detalhes"
            content={detalhesContent}
            trigger={{
                icon: "info circle",
                color: "blue",
            }}
        />
    );
};

export default StepTroca;
